export const COMPANY_NAME = "KIO EXPRESS INC";
export const COMPANY_SHORT = "Kio Express";
export const COMPANY_INITIALS = "KE";
export const COMPANY_ADDRESS_FULL = "12215 Butterfield Pl, Chino, California, US 91710-2329";
export const COMPANY_LOCATION = "Chino, California";
export const COMPANY_REGION = "Chino, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=12215%20Butterfield%20Pl%2C%20Chino%2C%20California%2C%20US%2091710-2329";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory" },
  { "label": "Location", "value": "Chino, California" },
  { "label": "Address", "value": "12215 Butterfield Pl" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "KIO EXPRESS INC" },
  { "label": "City / State", "value": "Chino, California" },
  { "label": "Address", "value": "12215 Butterfield Pl, Chino, California, US 91710-2329" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "TODO: Pillar 1", "body": "TODO: Customize." },
  { "icon": "✦", "title": "TODO: Pillar 2", "body": "TODO: Customize." },
  { "icon": "✿", "title": "TODO: Pillar 3", "body": "TODO: Customize." },
  { "icon": "❍", "title": "TODO: Pillar 4", "body": "TODO: Customize." },
];
